import React from 'react';
import {Link} from 'react-router-dom';
import {NAVY} from '../../tokens.js';
import {constatRecidive} from '../../selectors/analyses.js';
import CarteAnalyse from './CarteAnalyse.js';
import PetitTableau from './PetitTableau.js';

const COLONNES = [
    {cle: 'pav', libelle: 'PAV'},
    {cle: 'nb', libelle: 'Impossibles', droite: true},
    {cle: 'motif', libelle: 'Motif principal'},
];

/** Carte 1 (réel) : récidive des lavages impossibles. `resultat` = recidiveImpossibles(index). */
export default function CarteRecidive({resultat, slug, lienCarte}) {
    const lignes = resultat.top.map((t) => ({
        cle: t.pavId,
        pav: <Link to={`/pilotage/${slug}/pav/${t.pavId}`} style={{color: NAVY, fontWeight: 700, textDecoration: 'none'}}>{t.nomenclature}</Link>,
        nb: t.nb,
        motif: t.motif || '—',
    }));
    return (
        <CarteAnalyse id="analyse-recidive" titre="Récidive des lavages impossibles" source="reel" constat={constatRecidive(resultat)} lienCarte={lienCarte}>
            {lignes.length > 0 && <PetitTableau colonnes={COLONNES} lignes={lignes} legende="Les 10 PAV les plus touchés par les lavages impossibles"/>}
        </CarteAnalyse>
    );
}
